import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Typography, IconButton } from '@mui/material';
import { Description as DescriptionIcon, GetApp as GetAppIcon } from '@mui/icons-material';
import { DeleteWithConfirmButton } from '../atoms/DeleteWithConfirmButton'

import { deleteAllTransactionReportRequest } from '../../hooks/report/index'

import { default as dayjs } from "dayjs";

import React, { useState, PropsWithChildren, useEffect } from "react";

export type ReportRequestListModelType = {
  merchantId: number;
  reportUrl: string;
  status: string;
  createDate: string;
  createUserId: number;
};

export type ReportRequestListModalProps = PropsWithChildren<{
  isOpen: boolean;
  onClose?: () => void;
  title?: string;
  reportFiles: [ReportRequestListModelType];
  closeButtonText?: string;
  reportType?: number; // yeni prop
}>;

export const ReportRequestListModal = ({
  isOpen,
  onClose,
  title,
  closeButtonText,
  reportFiles,
  reportType // yeni prop
}: ReportRequestListModalProps) => {
  const [reportFilesState, setReportFiles] = useState<ReportRequestListModelType[]>([]);

  useEffect(() => {

    setReportFiles(reportFiles);

  }, [reportFiles])

  const statusMapping = [
    {
      key: 'PENDING',
      value: 'Bekleniyor'
    },
    {
      key: 'SUCCESS',
      value: 'Tamamlandı'
    },
    {
      key: 'FAIL',
      value: 'Hata Oluştu'
    }
  ]

  const downloadFile = (fileUrl: string, fileName: string) => {
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName;

    // Append to the document
    document.body.appendChild(link);

    // Trigger click event to download the file
    link.click();

    // Remove the link from the document
    document.body.removeChild(link);
  };

  const handleDeleteAllReports = async () => {
    // reportType varsa gönderiyoruz, yoksa eski davranış aynen devam
    await deleteAllTransactionReportRequest(reportType);
    setReportFiles([]);
  }

  return (
    <>
      <Dialog
        open={isOpen}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth={'lg'}
      >
        <DialogTitle id="alert-dialog-title">
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <span>{title || "Raporlar"}</span>
            {reportFilesState.length > 0 && <DeleteWithConfirmButton text='TÜM RAPORLARI SİL' size='small' onConfirm={handleDeleteAllReports} />}
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          <Box display="flex" alignItems="center" justifyContent="space-between" mb={1} fontWeight="fontWeightBold" sx={{ borderBottom: '1px solid gray', pb: 1 }}>
            <Typography variant="body1">Dosya</Typography>
            <Typography variant="body1">Durumu</Typography>
            <Typography variant="body1">İşlem Tarihi</Typography>
            <Typography variant="body1">#</Typography>
          </Box>
          {reportFilesState?.map((file, index) => (
            <Box key={index} display="flex" alignItems="center" justifyContent="space-between" width={800} sx={{ borderBottom: '1px solid lightgray' }} marginBottom={1}>
              <Box display="flex" alignItems="center">
                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="35" height="35" viewBox="0 0 48 48">
                  <path fill="#169154" d="M29,6H15.744C14.781,6,14,6.781,14,7.744v7.259h15V6z"></path><path fill="#18482a" d="M14,33.054v7.202C14,41.219,14.781,42,15.743,42H29v-8.946H14z"></path><path fill="#0c8045" d="M14 15.003H29V24.005000000000003H14z"></path><path fill="#17472a" d="M14 24.005H29V33.055H14z"></path><g><path fill="#29c27f" d="M42.256,6H29v9.003h15V7.744C44,6.781,43.219,6,42.256,6z"></path><path fill="#27663f" d="M29,33.054V42h13.257C43.219,42,44,41.219,44,40.257v-7.202H29z"></path><path fill="#19ac65" d="M29 15.003H44V24.005000000000003H29z"></path><path fill="#129652" d="M29 24.005H44V33.055H29z"></path></g><path fill="#0c7238" d="M22.319,34H5.681C4.753,34,4,33.247,4,32.319V15.681C4,14.753,4.753,14,5.681,14h16.638 C23.247,14,24,14.753,24,15.681v16.638C24,33.247,23.247,34,22.319,34z"></path><path fill="#fff" d="M9.807 19L12.193 19 14.129 22.754 16.175 19 18.404 19 15.333 24 18.474 29 16.123 29 14.013 25.07 11.912 29 9.526 29 12.719 23.982z"></path>
                </svg>
                <Typography variant="body1" ml={1}></Typography>
              </Box>
              <Box display="flex" alignItems="center">
                <Typography variant="body1">{statusMapping.find(x => x.key == file.status)?.value}</Typography>
              </Box>
              <Box display="flex" alignItems="center">
                <Typography variant="body1">{dayjs(file.createDate).format("DD.MM.YYYY HH:mm")}</Typography>
              </Box>
              <IconButton color="primary" onClick={() => {
                downloadFile(file.reportUrl, `${file.createUserId}_${file.createDate}.xlsx`);
              }} disabled={file.status != 'SUCCESS'}>
                <GetAppIcon />
              </IconButton>
            </Box>
          ))}
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>{closeButtonText || "Kapat"}</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
